import React from "react";
import Text from "@/components/ui/text";

interface Props {
  label: string;
  htmlFor?: string;
}

const FieldLabel: React.FC<Props> = ({ label, htmlFor }) => (
  <Text as="label" htmlFor={htmlFor} variant="bodySecondary">
    {label}
    <span className="text-primary ml-1">*</span>
  </Text>
);

export default FieldLabel;
